import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './representative-company.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const RepresentativeCompanyDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const representativeCompanyEntity = useAppSelector(state => state.representativeCompany.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="representativeCompanyDetailsHeading">
          <Translate contentKey="fleetSenseApp.representativeCompany.detail.title">RepresentativeCompany</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{representativeCompanyEntity.id}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.representativeCompany.company">Company</Translate>
          </dt>
          <dd>{representativeCompanyEntity.company ? representativeCompanyEntity.company.id : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.representativeCompany.targetCompany">Target Company</Translate>
          </dt>
          <dd>{representativeCompanyEntity.targetCompany ? representativeCompanyEntity.targetCompany.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/representative-company" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/representative-company/${representativeCompanyEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RepresentativeCompanyDetail;
